import { useEffect, useState } from 'react';
import { Container, Row, Col, Table, Form } from 'react-bootstrap';
// import lailaolab from './lailaolab.png';

// constants
import { COLOR_WHITE, S3_URL } from '../../const';
import { convertCurrency, convertDeliveryMethod, convertOrderStatus, numberFormat } from '../../helper';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';
import { GET_ORDERGROUP } from '../../apollo/ordergroup/query';
import { useLazyQuery } from '@apollo/client';
import { GET_BANKS } from '../../apollo/bank/query';
import { GET_OFFERPRICEDATA } from '../../apollo/offerpricegroup/query';

const BillOfferPriceV2 = ({ shopData, localOrder, titleBill, orderStatus, componentType }) => {
    const { t } = useTranslation();
    const [orderGroupData, setOrderGroupData] = useState();
    const [bankAccount, setBankAccount] = useState([])

    // Calculate the difference in milliseconds
    const orderLists = orderGroupData?.offerprices || orderGroupData?.orders;
    const [orderGroup, { loading }] = useLazyQuery(GET_ORDERGROUP, { fetchPolicy: "cache-and-network" });
    const [offerPriceGroup, { loading: loadingOfferPrice }] = useLazyQuery(GET_OFFERPRICEDATA, { fetchPolicy: "cache-and-network" });
    const [getBank, { data: getbankData, loading: loadingBanks }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });

    useEffect(() => {
        if (getbankData) {
            setBankAccount(getbankData?.banks?.data);
        }
    }, [getbankData]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchOrder = async (signal) => {
            try {

                if(componentType === "OFFERPRICE") {
                    const result = await offerPriceGroup({
                        variables: {
                            where: {
                                id: localOrder?.id,
                            },
                        },
                        context: { fetchOptions: { signal } },
                    });
                    // console.log("result: ", result)
                    setOrderGroupData(result?.data?.offerpriceGroup);
                } else {
                    const result = await orderGroup({
                        variables: {
                            where: {
                                id: localOrder?.id,
                            },
                        },
                        context: { fetchOptions: { signal } },
                    });
                    setOrderGroupData(result?.data?.orderGroup);
                }
            } catch (error) {
                console.log("error fetchOrder: ", error);
            }
        }
        if (localOrder?.id) {
            fetchOrder(signal);
        }
        return () => {
            controller.abort();
        };
    }, [localOrder?.id]);


    useEffect(() => {
        _fetchBank()
    }, [])
    // fetch bank datas
    const _fetchBank = async () => {
        let _localShop = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (!_localShop) return;
        try {
            await getBank({
                variables: {
                    limit: 100,
                    orderBy: "createdAt_DESC",
                    where: {
                        shop: _localShop?.id,
                        isDeleted: false,
                    },
                },
            });
        } catch (error) {
            console.log(error)
        }
    };

    const start = new Date(orderGroupData?.createdAt);
    const end = new Date(orderGroupData?.paymentDate);

    // Calculate the difference in milliseconds
    const diffInMilliseconds = end - start;

    // Convert milliseconds to days
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

    return (
        <Container className="mt-5">
            <Row>
                <Col style={{ textAlign: 'right' }}>
                    <img src={S3_URL + shopData?.image} alt={shopData?.name} style={{ maxWidth: 80 }} />
                </Col>
                <Col style={{ minWidth: 350 }}>
                    <h5 className="text-center">{shopData?.name ?? "-"}</h5>
                    <p style={{ marginTop: -10 }} className="text-center">{shopData?.address?.village}, {shopData?.address?.district}, {shopData?.address?.province}</p>
                    <p style={{ marginTop: -10 }} className="text-center">ເບີໂທ: {shopData?.phone ?? "-"} ເລກລະຫັດວິສາຫະກິດ​: {shopData?.businessNumber ?? "...."}</p>
                    <h4 style={{ fontWeight: 'bold', textAlign: 'center' }}><b>{titleBill ?? "ໃບເກັບເງິນ (Invoice)"}</b></h4>
                </Col>
                <Col></Col>
            </Row>

            <Row className="my-4">
                <Col>
                    <p style={{ marginTop: -10 }}><strong>{t("customer_name")}:</strong> {orderGroupData?.userConfirm?.name ?? "-"} {orderGroupData?.userConfirm?.lastname ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("address")}:</strong> {orderGroupData?.userConfirm?.address?.village ?? "-"}, {orderGroupData?.userConfirm?.address?.district ?? "-"}, {orderGroupData?.userConfirm?.address?.province ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("phone_number")}:</strong> {orderGroupData?.userConfirm?.phone ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>ພະນັກງານຂາຍ:</strong> {orderGroupData?.createdBy?.firstName ?? "-"} {orderGroupData?.createdBy?.lastName ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>ລະຫັດເຊວຂາຍ:</strong> {orderGroupData?.createdBy?.staffCode ?? "....."}</p>
                    <p style={{ marginTop: -10 }}><strong>ເບີໂທເຊວຂາຍ:</strong> {orderGroupData?.createdBy?.phone ?? "-"}</p>
                </Col>
                <Col>
                    <p style={{ marginTop: -10 }}><strong>ເລກໃບບິນ:</strong> {orderGroupData?.code ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("day_month_year")}:</strong> {moment(orderGroupData?.createdAt).format('DD/MM/YYYY')}</p>
                    <p style={{ marginTop: -10 }}><strong>ໄລຍະເວລາ:</strong> {"..."}</p>
                    <p style={{ marginTop: -10 }}><strong>ກຳນົດວັນຊຳລະ:</strong> {moment(orderGroupData?.paymentDate).format('DD/MM/YYYY')}</p>
                    <div style={{ display: 'flex', gap: "3em" }}>
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="KIP"
                            checked={orderGroupData?.currency === "LAK" ? true : false}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            checked={orderGroupData?.currency === "BAHT" ? true : false}
                            label="THB"
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            checked={orderGroupData?.currency === "USD" ? true : false}
                            label="USD"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {/* <p><strong>ພະນັກງານຂາຍ:</strong> {orderGroupData?.staff ?? "-"} {orderGroupData?.staffLastname ?? "-"}</p> */}
                </Col>
                {/* <Col>
                    <p><strong>ລະຫັດເຊວຂາຍ:</strong> .....</p>
                </Col>

                <Col>
                    <p><strong>ເບີໂທ:</strong> .....</p>
                </Col> */}
                <Col >
                    <div style={{ display: 'flex', gap: 16 }}>

                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ເຄດິດ"
                            checked={(orderGroupData?.status === "NOTYETPAID" || orderGroupData?.status === "INDEBTED") ? true : false}
                            style={{ minWidth: 80 }}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ສົດ"
                            checked={orderGroupData?.payment === "CASH" ? true : false}
                            style={{ minWidth: 80 }}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ໂອນ"
                            checked={orderGroupData?.payment === "TRANSFER" ? true : false}
                            style={{ minWidth: 80 }}
                        />
                    </div>
                </Col>
            </Row>

            <Table responsive bordered >
                <thead style={{ background: COLOR_WHITE }}>
                    <tr>
                        <th style={{ color: "#000", textAlign: 'center' }} >ລຳດັບ <br /> (No)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ຊື່ສິນຄ້າ<br />(Product)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ຂະຫນາດ<br />(Size)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ຈຳນວນ<br />(Qty)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ແຖມ<br />(Free)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ລາຄາ<br />(Unit)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ເປັນເງິນ<br />(Amount)</th>
                    </tr>
                </thead>
                <tbody>
                    {orderLists?.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.productName ?? "-"}</td>
                            <td>
                                {item?.stock?.size ?? '-'}
                                {item?.stock?.dimension?.length ? '(' + item?.stock?.dimension?.length + 'x'
                                    + item?.stock?.dimension?.width + 'x' + item?.stock?.dimension?.height + 'x'
                                    + item?.stock?.dimension?.weight + ')' : ''}
                            </td>
                            <td align="center">{item?.amount} {item?.stock?.unit ?? item?.stock?.unitId?.name ?? ""}</td>
                            <td align="center">{item?.amountFree ?? 0} {item?.stock?.unit ?? item?.stock?.unitId?.name ?? ""}</td>
                            <td>
                                <div className="d-flex justify-content-between">
                                    <span>{convertCurrency(item?.currency ?? "LAK")}</span>
                                    <span>{numberFormat(item?.price)}</span>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex justify-content-between">
                                    <span>{convertCurrency(item?.currency ?? "LAK")}</span>
                                    <span>{numberFormat(item?.amount * item?.price)}</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={4} >
                            <div>
                                <p className="font-medium"><b>ບັນຊີທະນາຄານ</b></p>
                                <p style={{ marginTop: -8 }}>ຊື່ບັນຊີ: {bankAccount[0]?.bankUser ?? "-"}</p>
                                <div className="d-flex gap-3">
                                    <div className="d-flex">
                                        <div className="pl-4 space-y-1 " style={{ lineHeight: 0.5 }}>
                                            {bankAccount?.map((bank, _index) => (
                                                <p key={bank?.id}><span></span> {" "} {bank?.bankAccount ?? "-"}</p>
                                            ))}
                                        </div>
                                    </div>
                                    <div style={{ border: '1px solid #d2d2d2', width: 100, height: 110}}>
                                        <img src={S3_URL + bankAccount[0]?.image} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td colSpan={2} rowSpan={3}>
                            <div className="p-4 d-flex justify-content-center align-items-center">
                                <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontSize: 18, paddingTop: 8 }}>ລວມເປັນກິບ</h5>
                                {/* <div />
                                <div />
                                <p style={{ marginTop: "3.85em" }}>ຄ່າຂົນສົ່ງ</p>
                                <p style={{ marginTop: -10 }}>ສ່ວນຫຼຸດ</p>
                                <p style={{ marginTop: -10 }}>ອາກອນ(Tax)</p>
                                <h5 style={{ fontWeight: 'bold', fontSize: 20, borderTop: '1px solid #dddd', paddingTop: 9 }}>ລວມທັງໝົດ</h5> */}
                            </div>
                        </td>
                        <td rowSpan={4}>
                            <div className="p-4 d-flex justify-content-center align-items-center">
                                {/* <p style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {numberFormat(orderGroupData?.totalPrice ?? 0)}</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>฿</span> {numberFormat(orderGroupData?.sumPriceBaht ?? 0)}</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>$</span> {numberFormat(orderGroupData?.sumPriceUsd ?? 0)}</p>
                                <p style={{ marginTop: -5, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {numberFormat(orderGroupData?.shippingCost ?? 0)}</p>
                                <p style={{ marginTop: -5, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {orderGroupData?.discount ?? 0}%</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> 0</p> */}
                                {/* <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontWeight: 'bold', fontSize: 20, paddingTop: 8 }}><span>₭</span>  {numberFormat(orderGroupData?.sumPrice ?? 0)}</h5> */}
                                <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontSize: 18, paddingTop: 8 }}>
                                    <span>₭</span>
                                    <span>{numberFormat(orderGroupData?.sumPrice ?? 0)}</span>
                                </h5>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>


            <p style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: 16 }}>ຂອບໃຈທີ່ທ່ານເຊື່ອໝັ້ນໃນບໍລິສັດຂອງພວກເຮົາ (Thank you for trusting our company!)</p>


            <Row className="mt-5 d-flex justify-content-start align-items-start">
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນການເງິນ</strong></p>
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>Payee's signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນຜູ້ຈັດສົ່ງ</strong></p>
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>Sender's signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນລູກຄ້າ</strong></p>
                    <p style={{ textAlign: 'center', marginTop: -10, fontSize: 12 }}><strong>Customer Acceptance Signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ກາຈ້ຳ ແລະ ລາຍເຊັນບໍລິສັດ</strong></p>
                    <p style={{ textAlign: 'center', marginTop: -10, fontSize: 12 }}><strong>Company Stamp and Authorized Signature</strong></p>
                    {/* <img 
                        src={lailaolab} 
                        alt="Company Stamp" 
                        style={{ 
                            maxWidth: 120, 
                            maxHeight: 100, 
                            objectFit: 'contain',
                            margin: 0,
                            padding: 0,
                            marginTop: -15,
                        }} 
                    /> */}
                </Col>
            </Row>
        </Container>
    );
};

export default BillOfferPriceV2;
